import { useRouter } from 'next/router';
import React from 'react';

const languages = ['en', 'de', 'fr', 'it', 'es'];
const defaultLang = 'en';
const baseUrl = 'https://spiritory.com';

const LanguageAlternates: React.FC = () => {
  let router: any;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    router = useRouter();
  } catch (e) {
    // NextRouter was not mounted - return null to avoid 500 error
    return null;
  }
  
  if (!router || !router.asPath) {
    return null;
  }

  const { asPath } = router;

  // Get path without query string
  const pathWithoutQuery = asPath.split('?')[0];

  // In Next.js Pages Router, asPath often includes the locale prefix (e.g., /de/sku-name).
  // We need to strip it to generate absolute URLs for all languages correctly.
  let cleanPath = pathWithoutQuery;
  for (const lang of languages) {
    if (cleanPath.startsWith(`/${lang}/`)) {
      cleanPath = cleanPath.substring(lang.length + 1);
      break;
    } else if (cleanPath === `/${lang}`) {
      cleanPath = '';
      break;
    }
  }

  if (cleanPath === '/') cleanPath = '';
  if (cleanPath !== '' && !cleanPath.startsWith('/')) {
    cleanPath = '/' + cleanPath;
  }
  // Next.js uses the default trailingSlash: false, so canonical URLs have NO
  // trailing slash. hreflang alternates must match the canonical exactly –
  // otherwise they point at URLs that 308-redirect and Google flags them as
  // "page with redirect".

  return (
    <>
      {languages.map((lang) => {
        const isDefault = lang === defaultLang;
        const href = isDefault
          ? `${baseUrl}${cleanPath || '/'}`
          : `${baseUrl}/${lang}${cleanPath || '/'}`;

        return (
          <link
            key={lang}
            rel="alternate"
            hrefLang={lang}
            href={href}
          />
        );
      })}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${baseUrl}${cleanPath || '/'}`}
      />
    </>
  );
};

export default LanguageAlternates;
